var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white p-6"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "flex items-center tab shadow-border-b mt-20"
  }, _vm._l(_vm.tabList, function (tab) {
    return _c('div', {
      key: tab.title,
      staticClass: "px-6 py-3 relative cursor-pointer",
      class: [tab.isActive ? 'text-neutral-700 font-medium active' : 'text-neutral-500'],
      on: {
        "click": function ($event) {
          return _vm.selectTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.title) + " ")]);
  }), 0), _c('div', {
    staticClass: "content px-6 py-10"
  }, [_c(_vm.selectedTab.content, {
    tag: "component"
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Merchant")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v("Merchant 1")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Alamat")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v("Jl.Lebak Bulus 1 No.16, kelurahan lebak bulus, kecamatan cilandak, jakarta selatan")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Total Order")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v("5")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Total Price")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v("14.000")])]);

}]

export { render, staticRenderFns }